import Video2 from './Video2'
export default Video2
